module.exports = __webpack_public_path__ + "static/accept-terms-conditions-4921611825b4c28d3473f7deb8a01674.png";